import React from "react";

import { NOTIFICATION_BADGE_CONFIG, formatBadgeLabel } from "../../../constants/notificationBadgeConfig";

const DEFAULT_BADGE_CONFIG = { backgroundColor: "#34D399", color: "#230E2F" };

const NotificationBadge = ({ type, label }) => {
  const normalizedType = typeof type === "string" ? type.trim() : "";
  const config =
    NOTIFICATION_BADGE_CONFIG[normalizedType] ||
    NOTIFICATION_BADGE_CONFIG[normalizedType.toUpperCase()] ||
    DEFAULT_BADGE_CONFIG;
  if (!label && !normalizedType) return null;

  const badgeLabel = formatBadgeLabel(label || normalizedType);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: "16px",
        paddingRight: "10px",
        paddingTop: "4px",
        paddingBottom: "4px",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.05em",
        fontFamily: "Poppins, sans-serif",
        whiteSpace: "nowrap",
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 8px 50%)",
        backgroundColor: config.backgroundColor,
        color: config.color,
      }}
    >
      {badgeLabel}
    </div>
  );
};

export default NotificationBadge;
